var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.5335 5.9915L10.0001 10.3498L2.4668 5.9915C2.80013 5.37484 3.28346 4.83317 3.82513 4.53317L8.27513 2.0665C9.22513 1.53317 10.7751 1.53317 11.7251 2.0665L16.1751 4.53317C16.7168 4.83317 17.2001 5.37484 17.5335 5.9915Z",
    fill: "#356BE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.0005 10.35V18.3334C9.37552 18.3334 8.75052 18.2 8.27552 17.9334L3.82552 15.4667C2.81719 14.9084 1.99219 13.5084 1.99219 12.3584V7.6417C1.99219 7.10837 2.17552 6.52503 2.46719 5.9917L10.0005 10.35Z",
    fill: "#356BE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0093 7.6417V12.3584C18.0093 13.5084 17.1843 14.9084 16.176 15.4667L11.726 17.9334C11.251 18.2 10.626 18.3334 10.001 18.3334V10.35L17.5343 5.9917C17.826 6.52503 18.0093 7.10837 18.0093 7.6417Z",
    fill: "#356BE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxItem);
export default __webpack_public_path__ + "static/media/boxItem.900960e2621f0b25e27f0dd7c6d6802c.svg";
export { ForwardRef as ReactComponent };